import React from "react";
import ReactPlayer from "react-player";

function Video() {
  const imageClick = () => {
    console.log("Click");
  };

  return (
    <section className="container px-4 py-10 mx-auto lg:h-128 lg:space-x-8 lg:flex lg:items-center">
      <div className="videowrapper aspect-w-16 aspect-h-9">
        <ReactPlayer
          url="http://www.youtube.com/watch?v=4VaqA-5aQTM"
          width="100%"
          height="100%"
        />
      </div>
      <div className="playbutton" onClick={() => imageClick()}></div>
    </section>
  );
}

export default Video;
